import * as React from 'react';
import {EditBreadcrumb, IState} from "./Data";
import API from '../../common/AxoisClient';
import {SSOSettingModel} from "../../model/SSOSetting";
import {RouteComponentProps} from "react-router";
import {PageForm} from "./form/SSOSettingForm"
import {CreateLayout} from "../../layout/CreateLayout";

export class SSOUpdate extends React.Component<RouteComponentProps, IState > {
  state: IState;

  constructor(props:any){
    super(props);
    this.state = {
      id: props.match.params.id,
      ssoSetting: {} as SSOSettingModel
    }
  }

  init = async () => {
    const res = await API.get(`settings/sso-setting/${this.state.id}`);
    this.setState({
      ssoSetting: res.data
    })
  }

  componentDidMount() {
    this.init();
  }


  render() {
    return (
        <CreateLayout breadcrumb={EditBreadcrumb} title={'Edit'}>
          <PageForm {...this.state}/>
        </CreateLayout>
    )
  }
}